import { VBtn, VCard, VCardTitle } from "vuetify/lib";
// Textareas_Field
import { createFTinfor, createTeam } from "./utils";
import { common_mixins } from "./EditMixIns.jsx";
import XMFTItem from "./XMFTItem";
import styles from "./index.module.less";
import { importDataApi } from "./service";
export default {
  mixins: [common_mixins],
  computed: {
    totalPrice() {
      let total = 0;
      for (let i = 0, len = this.params.expenses.length; i < len; i++) {
        total = math.eval(`${total}+${this.$refs[i].team_price_total || 0}`);
      }
      return total.toFixed(2);
    },
  },
  methods: {
    upload() {
      this.el = document.createElement("input");
      this.el.setAttribute("type", "file");
      this.el.style.display = "none";
      this.$refs.contain.appendChild(this.el);
      this.el.click();
      this.el.addEventListener("change", () => {
        const file = this.el.files[0];
        if (
          file &&
          ["xlsx", "csv", "xls", "excel", "spreadsheetml.sheet"].some(
            (item) => {
              return file.type.includes(item);
            }
          )
        ) {
          // 符合格式
          const params = new FormData();
          params.append("datafile", file);

          this.saving = true;
          importDataApi(params)
            .then((res) => {
              res = res || [];
              this.params.expenses = [];
              res.forEach((item) => {
                const o = createFTinfor();
                o.name = item.name;
                o.expense_teams = (item.expense_teams || []).map((i) => {
                  return {
                    ...createTeam(),
                    ...i,
                  };
                });
                if (o.expense_teams.length === 0) {
                  o.expense_teams = [createTeam()];
                }
                this.params.expenses.push(o);
              });
              if (!this.params.expenses.length) {
                this.params.expenses = [createFTinfor()];
              }
              this.$Message.success("上传成功！");
            })
            .finally(() => {
              this.saving = false;
              this.el &&
                this.el.removeEventListener &&
                this.el.removeEventListener("change", this.uploadFile);
            });
          return;
        }
        this.$Message.error("不支持该格式！");
      });
    },
    validate() {
      let go = true;
      for (let i = 0, len = this.params.expenses.length; i < len; i++) {
        if (!this.$refs[i].validate()) {
          go = false;
        }
      }
      return go;
    },
    resetValidation() {
      for (let i = 0, len = this.params.expenses.length; i < len; i++) {
        this.$refs[i] && this.$refs[i].resetValidation();
      }
    },
  },
  render() {
    const _this = this;
    return (
      <div class={styles["block-margin"]} ref="contain">
        <VCard flat light>
          <VCardTitle>
            项目分摊信息
            {!this.params.is_period_closed && (
              <VBtn
                class={styles["btn-f"]}
                outlined
                color="primary"
                small
                on={{
                  click: () => {
                    _this.params.expenses.push(createFTinfor());
                  },
                }}
              >
                添加项目
              </VBtn>
            )}
            <VBtn
              class={styles["btn-f"]}
              // outlined
              color="primary"
              small
              on={{
                click: this.upload,
              }}
            >
              导入
            </VBtn>
            <a
              style="margin-left:10px;font-size:10px"
              href="/static/files/批量导入分团队的数据模板.xlsx"
              target="_blank"
            >
              模版下载
            </a>
          </VCardTitle>
          {_this.params.expenses.map((item, index) => {
            return (
              <XMFTItem
                ref={`${index}`}
                on={{
                  del: (i) => {
                    _this.params.expenses.splice(i, 1);
                  },
                  changePrice: () => {
                    _this.$nextTick(() => {
                      _this.$emit("changePrice", _this.totalPrice);
                    });
                    //   _this.params.total_price = _this.changePrice()
                  },
                }}
                params={_this.params}
                key={index}
                index={index}
                total={_this.params.expenses.length}
                v-model={item}
              />
            );
          })}
        </VCard>
      </div>
    );
  },
};
